import React, { useState } from 'react'

export default function BeforeAfterCare() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <section className="py-12 px-6 md:px-12 lg:px-20 bg-white animate-on-scroll">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center justify-between p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all"
          style={{ borderLeft: '4px solid var(--medispa-olive)' }}
        >
          <h2 className="text-2xl md:text-3xl font-light text-[#2c3424]">
            Njega prije i poslije tretmana
          </h2>
          <svg
            className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`}
            style={{ color: 'var(--medispa-olive)' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        
        {isOpen && (
          <div className="mt-6 grid md:grid-cols-2 gap-8 animate-fadeIn">
            {/* Before Treatment */}
            <div className="bg-white p-6 rounded-lg border border-gray-200">
              <h3 className="text-xl font-light mb-4 text-[#2c3424]">Prije tretmana</h3>
              <ul className="space-y-3 text-[#1a1a1a] text-base leading-relaxed">
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Izbjegavajte sunčanje 2 tjedna</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Ne depilirajte voskom i ne čupajte dlačice</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Obrijte područje 24 sata prije tretmana</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Izbjegavajte proizvode za samotamnjenje</span>
                </li>
              </ul>
            </div>
            
            {/* After Treatment */}
            <div className="bg-white p-6 rounded-lg border border-gray-200">
              <h3 className="text-xl font-light mb-4 text-[#2c3424]">Nakon tretmana</h3>
              <p className="text-[#1a1a1a] mb-3 text-sm">Moguća je blaga crvenoća koja se povlači unutar nekoliko sati.</p>
              <p className="text-[#1a1a1a] mb-3 font-medium text-sm">48 sati izbjegavajte:</p>
              <ul className="space-y-3 text-[#1a1a1a] text-base leading-relaxed">
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Saunu i teretanu</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Bazene</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 text-[#2c3424] font-bold">•</span>
                  <span>Izravno sunčevo svjetlo</span>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}